import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

const authHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Obtener todos los campus activos (AllowAny — sin token)
export const getCampusDropdown = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/financiero/campus-dropdown/`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener campus:', error);
    throw error;
  }
};

// Obtener todos los ciclos escolares activos
export const getCiclosEscolaresDropdown = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/financiero/ciclos-dropdown/`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener ciclos escolares:', error);
    throw error;
  }
};

// Obtener el ciclo escolar actual detectado por fecha del servidor
export const getCicloActual = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/financiero/ciclo-actual/`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener ciclo actual:', error);
    throw error;
  }
};

// Obtener estudiantes con filtros opcionales
export const getEstudiantes = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    
    if (filters.campus) params.append('campus', filters.campus);
    if (filters.cicloEscolar) params.append('ciclo_escolar', filters.cicloEscolar);
    if (filters.search) params.append('search', filters.search);
    if (filters.estatus) params.append('estatus_estudiante', filters.estatus);
    
    const response = await axios.get(
      `${API_BASE_URL}/escolar/estudiantes/?${params.toString()}`,
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error al obtener estudiantes:', error);
    throw error;
  }
};

// Obtener un estudiante por ID
export const getEstudianteById = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/escolar/estudiantes/${id}/`, { headers: authHeaders() });
    return response.data;
  } catch (error) {
    console.error('Error al obtener estudiante:', error);
    throw error;
  }
};

// Obtener detalle completo del estudiante con sus pagos para inscripción
export const getDetalleEstudianteInscripcion = async (estudianteId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/escolar/estudiantes/${estudianteId}/detalle-inscripcion/`,
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error al obtener detalle del estudiante:', error);
    throw error;
  }
};

// Aplicar inscripción/reinscripción a un estudiante
export const aplicarInscripcion = async (inscripcionData) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/escolar/inscripciones/aplicar/`,
      inscripcionData,
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error al aplicar inscripción:', error);
    
    if (error.response && error.response.data) {
      throw {
        message: error.response.data.error || 'Error al aplicar inscripción',
        details: error.response.data
      };
    }
    
    throw error;
  }
};


// Obtener estudiantes clasificados (con adeudo / sin adeudo) para reinscripción
export const getEstudiantesReinscripcion = async (campusId, cicloId, search = '') => {
  try {
    const params = new URLSearchParams();
    params.append('campus_id', campusId);
    params.append('ciclo_id', cicloId);
    if (search) params.append('search', search);

    const response = await axios.get(
      `${API_BASE_URL}/financiero/reinscripcion/estudiantes/?${params.toString()}`,
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error al obtener estudiantes para reinscripción:', error);
    throw error;
  }
};

export default {
  getCampusDropdown,
  getCiclosEscolaresDropdown,
  getCicloActual,
  getEstudiantes,
  getEstudianteById,
  getDetalleEstudianteInscripcion,
  aplicarInscripcion,
  getEstudiantesReinscripcion,
};


// Enviar correo de recordatorio/boleta de reinscripción
// Soporta adjunto PDF opcional
export const enviarRecordatorioReinscripcion = async (estudiantesIds, mensaje, asunto, adjuntoPdf = null) => {
  try {
    let response;
    if (adjuntoPdf) {
      // Enviar como multipart/form-data para soportar archivo adjunto
      const formData = new FormData();
      formData.append('estudiantes_ids', JSON.stringify(estudiantesIds));
      formData.append('mensaje', mensaje);
      formData.append('asunto', asunto);
      formData.append('adjunto_pdf', adjuntoPdf);
      response = await axios.post(
        `${API_BASE_URL}/financiero/reinscripcion/enviar-recordatorio/`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data', ...authHeaders() } }
      );
    } else {
      response = await axios.post(
        `${API_BASE_URL}/financiero/reinscripcion/enviar-recordatorio/`,
        { estudiantes_ids: estudiantesIds, mensaje, asunto },
        { headers: authHeaders() }
      );
    }
    return response.data;
  } catch (error) {
    console.error('Error al enviar recordatorio:', error);
    throw error;
  }
};
